export default class Room {
  constructor(
    uuid,
    internalName,
    marketingName,
    code,
    lockType,
    dynamicPricing,
    tag,
    {
      description,
      minPrice,
      maxPrice,
      autoAdjustmentPercentage,
      price,
      roomImage,
      propertyName
    },
    percentage,
    color,
    percentagePrevious
  ) {
    this.uuid = uuid
    this.internalName = internalName
    this.marketingName = marketingName
    this.code = code
    this.description = description
    this.lockType = lockType
    this.dynamicPricing = dynamicPricing
    this.maxPrice = maxPrice
    this.minPrice = minPrice
    this.autoAdjustmentPercentage = autoAdjustmentPercentage
    this.price = price
    this.roomImage = roomImage
    this.percentage = percentage
    this.color = color
    this.percentagePrevious = percentagePrevious
    this.tag = tag
    this.propertyName = propertyName
  }
}
